import { mutate } from "swr";

import * as fetcher from "../fetcher";

export const asociateAppointment = (
  projectdId: number,
  appointmentId?: string
) => {
  if (!projectdId || !appointmentId) {
    return null;
  }
  return fetcher.opportunity
    .post(`/${projectdId}/appointments/${appointmentId}`, {})
    .then(() => {
      mutate(`/opportunities/${projectdId}`);
      mutate(`/${projectdId}/appointments`);
      mutate(`/opportunities/${projectdId}/history`);
    });
};
